import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

// ============ CHECKLIST TEMPLATE QUERIES ============

export function useChecklistTemplates() {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.checklist.getTemplates.queryOptions())
}

export function useChecklistTemplate(id: string | null) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.checklist.getTemplate.queryOptions({ input: { id: id! } }),
    enabled: !!id,
  })
}

// ============ CHECKLIST TEMPLATE MUTATIONS ============

export function useChecklistTemplateCreate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.checklist.createTemplate.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.checklist.getTemplates.key() })
      },
    })
  )
}

export function useChecklistTemplateUpdate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.checklist.updateTemplate.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.checklist.getTemplates.key() })
      },
    })
  )
}

export function useChecklistTemplateArchive() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.checklist.archiveTemplate.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.checklist.getTemplates.key() })
      },
    })
  )
}

export function useChecklistTemplateDuplicate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.checklist.duplicateTemplate.mutationOptions({
      onSuccess: (created) => {
        const key = orpc.checklist.getTemplates.key()
        queryClient.setQueryData<typeof created[]>(key, (old) =>
          old ? [created, ...old] : [created]
        )
        queryClient.invalidateQueries({ queryKey: key })
      },
    })
  )
}

